import React, { useCallback } from "react";
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  useNodesState,
  useEdgesState,
  addEdge,
  Position,
} from "@xyflow/react";

import "@xyflow/react/dist/style.css";

import CustomNode from "./components/customNode";

const nodeTypes = {
  customNode: CustomNode,
}

const nodeDefaults = {
  sourcePosition: Position.Right,
  targetPosition: Position.Left,
}

const initialNodes = [
  {
    id: "ios",
    type: "customNode",
    position: { x: 0, y: 0 },
    data: {
      isExternal: true,
      label: "Mobile(iOS)",
      description: "Expo",
      source: ['right'],
      debug: true
    },
    ...nodeDefaults
  },
  {
    id: "android",
    type: "customNode",
    position: { x: 0, y: 100 },
    data: {
      isExternal: true,
      label: "Mobile(Android)",
      description: "Expo",
      source: ['right']
    },
    ...nodeDefaults
  },
  {
    id: "admin",
    type: "customNode",
    position: { x: 0, y: 200 },
    data: {
      label: "Admin",
      description: "NextJS, Antd",
      source: ['right']
    },
    ...nodeDefaults
  },
  { 
    id: "gateway",
    type: "customNode",
    position: { x: 300, y: 100 }, 
    data: { 
      label: "Gateway", 
      description: 'Strapi',
      source: ['right'],
      target: ['left'],
      debug: true
    }, 
    ...nodeDefaults 
  },
  { 
    id: "db",
    type: 'customNode',
    position: { x: 600, y: 0 }, 
    data: { 
      label: "Store",
      description: "Postgres",
      target: ['left'],
      source: ['bottom'],
      debug: true
    }, 
    ...nodeDefaults },
  { 
    id: "cache",
    type: 'customNode',
    position: { x: 600, y: 150 }, 
    data: { 
      label: "Cache",
      description: "Redis",
      isExternal: true,
      target: ['left', 'top'],
      debug: true
    },
    ...nodeDefaults
  },
];

const initialEdges = [
  { id: "e1", source: "ios", target: "gateway", animated: true, label: "RESTFul / API"},
  { id: "e2", source: "android", target: "gateway", animated: true, label: "RESTFul / API" },
  { id: "e3", source: "admin", target: "gateway", animated: true, label: "RESTFul / API" },
  { id: "e4", source: "gateway", target: "cache", animated: true, label: "Load first" },
  { id: "e5", source: "gateway", target: "db", animated: true, label: "CRUD Operation" },
  { id: "e6", source: "db", target: "cache", animated: true, label: "Backup", targetHandle: 'cache1' },
];

const App = () => {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <div style={{ height: "100vh" }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
        nodeTypes={nodeTypes}
      >
        <MiniMap nodeColor={() => "lightblue"} />
        <Controls />
        <Background color="#aaa" gap={16} />
      </ReactFlow>
    </div>
  );
};

export default App;
